import React, { createContext } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { I18nProvider } from "@lingui/react";
import i18n from "./locals/i18n.js";
import UserStore from './components/store/userStore.js';

export const Context = createContext(null);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <I18nProvider i18n={i18n}>
    <BrowserRouter>
      <Context.Provider value={{ user: new UserStore() }}>
        <App />
      </Context.Provider>
    </BrowserRouter>
  </I18nProvider>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
